const admin = {
  'admin-loading': 'Cargando, por favor espere...',
  'geolocation-button': 'Geolocalización',
  'newsletter-button': 'Boletín informativo',
  'custom-modal-admin-button': 'imagen de la página de inicio'
};

export default admin;
